// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__oUUxa","label":"Section_label__3r7-h","contentWrap":"Section_contentWrap__3sUep","footer":"Section_footer__3Tqs3","footerInner":"Section_footerInner__30qac"};